import React from 'react';

import { Card, Heading } from '../../shared/ui';

import { DocumentActions } from './document-actions';

import { DemoBanner } from './DemoBanner';

export function ClientProfile() {
  return (
    <div className="space-y-4">
      <DemoBanner section="Профиль клиента" />

      <div className="bg-white border border-line rounded-control px-[20px] py-[10px]">
        <div className="flex items-center justify-between mb-4 pb-3 border-b border-surface-muted">
          <Heading size="md">Профиль клиента</Heading>
          <DocumentActions />
        </div>

        <div className="mb-1" />
      </div>

      <Card radius="control">
        <Heading size="xs" as="h4" className="mb-3">
          Потенциальные диагнозы МКБ-10
        </Heading>
        <div className="border border-surface-muted rounded-control overflow-hidden text-ui">
          {[
            ['Код МКБ-10', 'F43.23'],
            ['Название', 'Расстройство адаптации со смешанной тревогой и депрессией'],
            [
              'Обоснование',
              'Симптомы тревоги и вины, связанные с работой и отношениями. Трудности с самопомощью. Симптомы возникают в ответ на идентифицируемые стрессоры.',
            ],
          ].map(([label, value], i) => (
            <div key={i} className={`flex gap-3 px-4 py-2.5 ${i < 2 ? 'border-b border-surface-muted' : ''}`}>
              <span className="w-32 shrink-0 text-ink-muted text-ui-xs-strong">{label}</span>
              <span className="text-ink-muted text-ui-xs">{value}</span>
            </div>
          ))}
        </div>
      </Card>

      <Card radius="control">
        <Heading size="xs" as="h4" className="mb-3">
          История клиента
        </Heading>
        <div className="space-y-2 text-ui-xs text-ink-muted leading-relaxed">
          <p>
            26-летний предприниматель, владелец малого бизнеса. Диагноз: ГТР. Пережил эмоциональное пренебрежение в
            детстве — отец ушёл из семьи, мать была эмоционально недоступна.
          </p>
          <p>
            Дефицит постоянной привязанности сформировал паттерны перфекционизма ради избегания отвержения. Трудности с
            некомпетентным ассистентом и баланс работы/жизни.
          </p>
        </div>
      </Card>

      <Card radius="control">
        <Heading size="xs" as="h4" className="mb-3">
          Цели терапии
        </Heading>
        <ul className="space-y-1.5 text-ui-xs text-ink-muted">
          {[
            'Снижение симптомов тревоги и уровня стресса',
            'Развитие навыков самосострадания и самоотношения',
            'Улучшение навыков установления здоровых границ',
            'Проработка детских паттернов привязанности',
          ].map((goal, i) => (
            <li key={i} className="flex items-start gap-2">
              <span className="text-accent mt-0.5">•</span>
              <span>{goal}</span>
            </li>
          ))}
        </ul>
      </Card>
    </div>
  );
}
